<!-- Quick links toggle -->
<button
    mat-icon-button
    (click)="openPanel()"
    #shortcutsOrigin>
    <mat-icon [svgIcon]="'heroicons_outline:view-grid'"></mat-icon>
</button>

<!-- Quick links panel -->
<ng-template #shortcutsPanel>
    <div class="fixed inset-0 sm:static sm:inset-auto flex flex-col sm:min-w-90 sm:w-90 sm:rounded-2xl overflow-hidden shadow-lg">

        <!-- Header -->
        <div class="flex shrink-0 items-center py-4 pr-4 pl-6 bg-primary text-on-primary">
            <div class="sm:hidden -ml-1 mr-3">
                <button mat-icon-button (click)="closePanel()">
                    <mat-icon class="icon-size-5 text-current" [svgIcon]="'heroicons_solid:x'"></mat-icon>
                </button>
            </div>
            <div class="flex items-center text-lg font-medium leading-10">
                <span>{{ 'quickMenu.title' | translate }}</span>
            </div>
        </div>

        <div class="relative flex flex-col flex-auto sm:max-h-120 -mb-px overflow-y-auto bg-card">
            <!-- Quick links grid -->
            <div class="grid grid-cols-2 grid-flow-row">
                <ng-container *ngFor="let link of quickLinks; trackBy: trackByFn">
                    <a
                        class="flex flex-col items-center justify-center w-full h-full py-6 no-underline bg-card border-r border-b even:border-r-0 hover:bg-gray-50 dark:hover:bg-black dark:hover:bg-opacity-5"
                        [routerLink]="link.link"
                        (click)="closePanel()">
                        <div class="flex shrink-0 items-center justify-center w-12 h-12 mb-3 rounded-full bg-gray-100 dark:bg-gray-700">
                            <mat-icon [svgIcon]="link.icon"></mat-icon>
                        </div>
                        <div class="font-medium text-center">{{ link.labelKey | translate }}</div>
                    </a>
                </ng-container>
            </div>

            <!-- No links fallback -->
            <ng-container *ngIf="!quickLinks || !quickLinks.length">
                <div class="flex flex-col flex-auto items-center justify-center sm:justify-start py-12 px-8">
                    <div class="flex flex-0 items-center justify-center w-14 h-14 rounded-full bg-primary-100 dark:bg-primary-600">
                        <mat-icon class="text-primary-700 dark:text-primary-50" [svgIcon]="'heroicons_outline:view-grid'"></mat-icon>
                    </div>
                    <div class="mt-5 text-2xl font-semibold tracking-tight">{{ 'quickMenu.noLinks' | translate }}</div>
                </div>
            </ng-container>
        </div>
    </div>
</ng-template>
